<template>
  <div id="app1">
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg8 style="padding-bottom: 15px;">
          <v-flex lg12 md12 sm12 xs12 v-if="show_header" style="display: flex;">
            <v-flex md4 sm4 xs4 lg4>
              <v-img
                  :src="require('../assets/images/company_logo.png')"
                  class="company_logo"
                  style="width: 100px;"
              ></v-img>
            </v-flex>

            <v-flex lg8 md8 sm8 xs8 style="display: flex; justify-content: flex-start; align-items: center;">
              <h2>Live Train Tracking</h2>
            </v-flex>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 style="padding: 15px;">

            <v-flex v-show="map_loader">
              <v-progress-circular
                  :size="70"
                  :width="7"
                  color="white"
                  indeterminate
                  style="position:center; top: calc(80% - 25px); left: calc(70% - 25px);"
              ></v-progress-circular>
            </v-flex>

            <v-flex class="map-box" v-show="map_check_lat_long" >
              <h2>Something went wrong...</h2>
            </v-flex>

            <v-flex class="map-box" v-show="map_visible">
              <div id="map" ref="mapComponent"></div>
            </v-flex>

          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "upcomingTrains",
  data() {
    return {
      is_loading: false,
      map_visible: false,
      drawer: null,
      show_header: true,
      item_data: [],
      map1: '',
      map_check_lat_long: false,
      map_loader: false,
      msg_error: "",
      timer: null,
      markers: [],
    }
  },
  methods: {
    searchForTrains() {
      this.is_loading = true;
      this.map_loader = true;
      axios
          .post(`${process.env.VUE_APP_API_URL}/api/v1/get-trains-by-station-platform`, {
            station_name: this.$route.query.station_name,
            platform_number: this.$route.query.platform_number
          })
          .then(response => {
            if (response.data.status == 1) {
              this.map_loader = false;
              this.is_loading = false;
              this.map_check_lat_long = false;
              this.map_visible = true;
              this.show_header = true;
              this.setupLeafletMap(response.data.data);
            } else if (response.data.status == 0) {
              this.msg_error = "Something went wrong....";
              this.map_loader = false;
              this.map_visible = false;
              this.map_check_lat_long = true;
            }
          })
          .catch(error => {
            this.map_loader = false;
          })
          .finally(() => {
            this.map_loader = false;
            this.is_loading = false;
          });
    },
    setupLeafletMap(data) {
      this.map1.setView([data[0].latitude, data[0].longitude], 15);

      var icon = L.icon({
        iconUrl: require('../assets/images/train_icon.png'),
        iconRetinaUrl: require('../assets/images/train_icon.png'),
        iconSize: [30, 30],
      });

      let totalLat = 0;
      let totalLng = 0;

      data.forEach((element) => {
        let longitude, latitude;

        let iconOptions = {
          icon: icon
        }

        latitude = element.latitude;
        longitude = element.longitude;

        totalLat += latitude;
        totalLng += longitude;

        var marker = new L.Marker([latitude, longitude], iconOptions)

        if (element.nearest_station_position == "1") {
          let position;

          position = "Arriving at " + this.$route.query.station_name.charAt(0).toUpperCase() + this.$route.query.station_name.slice(1).toLowerCase();
          var popupContent = `
            <div class="custom-popup">
                <h3>${position} </h3>
            </div>`;

          var iconSize = icon.options.iconSize;

          marker.bindPopup(popupContent, {
            closeButton: false,
            offset: [latitude,longitude]
          }).openPopup();

          L.popup().setLatLng([latitude, longitude]).setContent(popupContent).openOn(this.map1);

        } else if (element.nearest_station_position == "0") {
          // let position;
          // position = "Left " + this.$route.query.station_name.charAt(0).toUpperCase() + this.$route.query.station_name.slice(1).toLowerCase();

        } else if (element.nearest_station_position == "2") {
          // position = "At " + this.$route.query.station_name.charAt(0).toUpperCase() + this.$route.query.station_name.slice(1).toLowerCase();

        }
        this.map1.setView([latitude, longitude], 15);

        marker.addTo(this.map1);
      });

      const avgLat = totalLat / data.length;
      const avgLng = totalLng / data.length;

      this.map1.setView([avgLat, avgLng], 16);
    },
    initMap() {
      this.map_loader = true;

      let mapOptions = {
        zoom: 13,
      }
      this.map1 = new L.map('map', {mapOptions, renderer: L.canvas()});

      this.map_visible = true;

      var layer = new L.TileLayer('https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', {
        maxZoom: 17,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });

      this.map1.addLayer(layer);
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
  },
  mounted() {
    this.initMap();
    this.searchForTrains();
    this.timer = setInterval(this.searchForTrains, 120000);
  }
}
</script>

<style scoped>
.leaflet-popup-content {
  width: 100% !important;
  margin: 10px 10px 10px 10px !important;
}

.leaflet-popup-content-wrapper {
  width: 90px !important;
}
#app1 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}

#map {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 85vh;
}
.map-box {
  background-color: #f3f3f3;
  height: 85vh;
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: space-around;
  align-content: space-around;
  flex-wrap: wrap;
}
</style>
